import React from "react"

const Button = ({ text }) => (
  <button className="px-8 py-4 text-lg uppercase font-bold bg-blue-600 hover:bg-blue-500 rounded transition-colors duration-150 ease-in-out">
    {text}
  </button>
)

export default Button
